import {fetchCompany} from "./_rx/jobs/actions";

if (process.env.NODE_ENV !== 'production') require('preact/debug');

import { h, render } from 'preact';
import App from './app/app-component';
import config from './config';
import {globalCatch} from "./_services/global-catch";
import {toastService} from "./_services/toast-service";
import JobsService from './_services/jobs';

// establece un catcher global
// para que se llame este catcher global hay que crear las async actions con
// globalCatch.catch(...)
globalCatch.setGlobalCatch((error:any)=>{

    console.log('GlobalCatch', error);

    error = error.body || error;

    //errores de validacion de formulario, cada key del diccionario es un campo con un array de errores
    if(error.errors && Object.values(error.errors).some(v=>Array.isArray(v))){
        error = Object.values(error.errors).map((v:any) => v.join(' ')).join(' ');
    }

    error = error.errors || error;
    error = error.error || error;
    error = error.message || error;
    error = error.msg || error;
    error = error.code || error;

    if(typeof error !== "string")
        error = JSON.stringify(error);

    error || error !== '{}' && toastService.showToast({message: error, type:'danger'});
});

config().then(()=> { // se carga primero la configuracion de env.json

    // ahora window.env esta cargado

    render(
        <App/>
        , document.getElementById('main-container') as any)

});


// Hot Module Replacement
declare var module : { hot : { accept(path?:string, callback?:() => void): void; };};
module.hot && module.hot.accept();
